import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { isUserRelationshipTarget } from '@core-engine/schema/system-relationships/is-user-relationship-target.js'
export function relationshipSelectShape(field: SchemaField, tableVar: string): string {
  return isUserRelationshipTarget(field.relationship)
    ? `{ id: ${tableVar}.id, name: ${tableVar}.name, email: ${tableVar}.email }`
    : `{ id: ${tableVar}.id, name: ${tableVar}.name, title: ${tableVar}.title, slug: ${tableVar}.slug, label: ${tableVar}.label }`
}
